import { useRef, useCallback } from 'react';

export const useCardHeights = (columnId) => {
  const heightsByIdRef = useRef({});
  const listRef = useRef(null);
  const defaultHeight = 220;

  const setListRef = useCallback((ref) => {
    listRef.current = ref;
  }, []);

  const setCardHeight = useCallback(
    (cardId, height) => {
      if (height && height > 0) {
        // Initialize column heights if needed
        if (!heightsByIdRef.current[columnId]) {
          heightsByIdRef.current[columnId] = {};
        }

        heightsByIdRef.current[columnId][cardId] = height;

        listRef?.current?.resetAfterIndex(0);
      }
    },
    [columnId]
  );

  const getCardHeight = useCallback(
    (cardId) => {
      // Get height by card ID
      return heightsByIdRef.current[columnId]?.[cardId] || defaultHeight;
    },
    [columnId]
  );

  const resetHeights = useCallback(() => {
    // Clear all heights for this column
    if (heightsByIdRef.current[columnId]) {
      heightsByIdRef.current[columnId] = {};
    }
    if (listRef.current) {
      listRef.current.resetAfterIndex(0);
    }
  }, [columnId]);

  const resetList = useCallback(() => {
    // Force list to recalculate all item sizes
    if (listRef.current) {
      listRef.current.resetAfterIndex(0, true);
    }
  }, []);

  return {
    getCardHeight,
    setCardHeight,
    resetHeights,
    resetList,
    setListRef,
    listRef,
  };
};
